// 母版管理
import React, { Fragment } from "react"
import Preset from "Components/Preset"

export default () => {
    return (
        <Fragment>
            <Preset calendarType="preset" />
            <div id="board_input_modal" />
        </Fragment>
    )
}
